import type { Submenu } from '@/shared/lib/cotas';

/**
 * Se um submenu nasce aberto ou fechado (`.spec/015`, decisões 75 e 105).
 *
 * A escolha do usuário, quando existe, vale sempre — a mesma regra das seções.
 * Sem ela, o padrão responde a duas perguntas:
 *
 * - **É "Processos"?** Então abre: é o lançamento de todo dia. Até a decisão
 *   105 ele nascia fechado na seção com favorito, porque o favorito ficava em
 *   cima dele; com o menu de Favoritos à parte, a seção não tem mais o que pôr
 *   no lugar.
 * - **A tela aberta está aqui dentro?** Então abre. Chegar numa tela pela
 *   busca ou por um link e ver o submenu dela fechado apagaria a única pista
 *   de onde se está.
 *
 * Cadastros e Relatórios nascem fechados: são o que se abre de vez em quando.
 */
export function submenuAbertoPorPadrao(submenu: Submenu, cotaAberta: string | null): boolean {
  if (cotaAberta !== null && submenu.itens.some((item) => item.cota === cotaAberta)) return true;
  return submenu.titulo === 'Processos';
}

/**
 * A chave do submenu na preferência gravada.
 *
 * Seção e submenu juntos, porque "Cadastros" existe em quatro seções e fechar
 * o de Financeiro não fecha o de Compras. O separador é a barra: nenhum título
 * de seção a usa.
 */
export function chaveDoSubmenu(secao: string, submenu: string): string {
  return `${secao}/${submenu}`;
}

/**
 * Lê a preferência gravada, tolerando qualquer imprevisto.
 *
 * Mapa de `chave → aberto`, e não lista de abertos como a das seções: aqui o
 * padrão muda de submenu para submenu, e só o mapa distingue "o usuário
 * fechou" de "o usuário nunca mexeu".
 */
export function lerSubmenusGravados(bruto: string | null): Record<string, boolean> {
  if (bruto === null) return {};

  try {
    const valor: unknown = JSON.parse(bruto);
    if (typeof valor !== 'object' || valor === null || Array.isArray(valor)) return {};

    return Object.fromEntries(
      Object.entries(valor).filter((par): par is [string, boolean] => typeof par[1] === 'boolean'),
    );
  } catch {
    return {};
  }
}
